import React from "react";
import PropTypes from "prop-types";
import { Button, Collapse } from "reactstrap";

import ExpressionBuilder from "shared/expression_builder/components/ExpressionBuilder";

export default class StaticExpressionCollapse extends React.Component {
  static propTypes = {
    expressionText:   PropTypes.string.isRequired,
    expressionNodes:  PropTypes.array.isRequired,
    terminalMetaData: PropTypes.object.isRequired,
    closeButtonLabel: PropTypes.string.isRequired,
    openButtonLabel:  PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleCollapsed = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { expressionText, expressionNodes, terminalMetaData, closeButtonLabel, openButtonLabel } = this.props;
    return (
      <span>
        <Button color="link" onClick={this.toggleCollapsed}>
          {this.state.isOpen ? closeButtonLabel : openButtonLabel}
        </Button>
        <Collapse isOpen={this.state.isOpen}>
          <ExpressionBuilder
            name="static_expression"
            expressionText={expressionText}
            expressionNodes={expressionNodes}
            editable={false}
            terminalMetaData={terminalMetaData}
          />
        </Collapse>
      </span>
    );
  }
}
